import React from 'react';
import {
  Variant,
  Item,
  SelectedItem,
  IPostUpsellVariant,
  ICurrentUpsellData,
  IUpsellData,
  ISelectedUpsellItems,
} from '../../../../page-builder/interface/postUpsellInterface';
import LoadingSpinner from '../../../../page-builder/components/shared/LoadingSpinner';
import { Cart } from '../../../interface/checkoutInterface';
import '../../../components/text-editor/style.scss';
import { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { getBorderProps, getPaddingStyles } from '../../../utils/helper';
import { PaddingType } from '../../../puck/reusable-props/padding';

export interface PostUpSellDealProps {
  titlePadding: PaddingType;
  offerPadding: PaddingType;
  selectedVariant: Variant;
  currentRecommendation: Item;
  postUpSellRecommendation: Item[];
  handleClick: () => Promise<void>;
  handleCompletePurchase: (
    _newSelectedItems: ISelectedUpsellItems[],
    _isNavToThankyouPage: boolean,
  ) => void;
  currentIndex: number;
  cartData: Cart | null;
  selectedItems: SelectedItem[];
  isLoading: boolean;
  title: string;
  offer: string;
  hideTitle?: boolean;
  hideOffer?: boolean;
  border: IBorderValueProps;
  bgColorOffer: {
    color: string;
    isInherit: boolean;
  };
  bgColorTitle: {
    color: string;
    isInherit: boolean;
  };
  maxWidth?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  height?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  currentDeviceType: 'mobile' | 'tablet' | 'desktop';
  upsellData: IUpsellData;
  selectedUpsellItems: {
    variantId: string;
    GroupId: string;
    IsDownsell: boolean;
    DownsellId?: string;
    ProductId: string;
  }[];
  currentUpsellData: ICurrentUpsellData;
  selectedVariantForSingleProduct: IPostUpsellVariant;
  fullWidth?: {
    desktop: boolean;
    mobile: boolean;
    tablet: boolean;
  };
  IndependentTransactionForUpsellPages: boolean;
  isPaymentPayPalCheckout?: boolean;
}

export const PostUpSellDeal: React.FC<PostUpSellDealProps> = ({
  isLoading,
  offerPadding,
  titlePadding,
  title,
  hideOffer,
  hideTitle,
  bgColorTitle,
  bgColorOffer,
  offer,
  border,
  maxWidth,
  height,
  currentDeviceType,
  fullWidth,
  handleClick,
}) => {
  const borderStyles = getBorderProps(border, currentDeviceType);

  const offerBorder = hideTitle
    ? {
        ...borderStyles,
      }
    : {
        borderBottomLeftRadius: borderStyles.borderBottomLeftRadius,
        borderBottomRightRadius: borderStyles.borderBottomRightRadius,
      };

  const titleBorder = hideOffer
    ? { ...borderStyles }
    : {
        borderTopLeftRadius: borderStyles.borderTopLeftRadius,
        borderTopRightRadius: borderStyles.borderTopRightRadius,
      };

  const buttonSize: React.CSSProperties =
    currentDeviceType &&
    maxWidth &&
    height &&
    maxWidth[currentDeviceType] !== undefined &&
    height[currentDeviceType] !== undefined
      ? {
          width: fullWidth?.[currentDeviceType]
            ? '100%'
            : isNaN(+maxWidth[currentDeviceType])
              ? maxWidth[currentDeviceType]
              : `${+maxWidth[currentDeviceType]}px`,

          height: isNaN(+height[currentDeviceType])
            ? height[currentDeviceType]
            : `${+height[currentDeviceType]}px`,
        }
      : {};

  return (
    <>
      <div className="relative">
        <button
          onClick={handleClick}
          className={`relativ text-center rounded-2xl w-full ${isLoading ? 'text-gray-500' : 'text-white '}} ${
            !hideOffer && !hideTitle && border?.borderStyle?.[currentDeviceType]
          }`}
          style={{
            ...(!hideOffer && !hideTitle ? borderStyles : {}),
          }}
          disabled={isLoading}>
          {!hideTitle && (
            <div
              style={{
                backgroundColor: bgColorTitle?.isInherit
                  ? 'inherit'
                  : bgColorTitle?.color,
                ...titleBorder,
                ...getPaddingStyles(titlePadding, currentDeviceType),
                ...buttonSize,
              }}
              className={`font-bold text-2xl  checkbox-content ${hideOffer && border?.borderStyle?.[currentDeviceType]}`}>
              <span dangerouslySetInnerHTML={{ __html: title }}></span>
            </div>
          )}
          {!hideOffer && (
            <>
              <div
                style={{
                  backgroundColor: isLoading
                    ? '#f3f4f6'
                    : bgColorOffer?.isInherit
                      ? 'inherit'
                      : bgColorOffer?.color,
                  color: isLoading ? '#9ca3af' : 'white',
                  ...offerBorder,
                  ...getPaddingStyles(offerPadding, currentDeviceType),
                  ...buttonSize,
                }}
                className={`font-bold text-2xl  checkbox-content  ${hideTitle && border?.borderStyle?.[currentDeviceType]}`}>
                <span dangerouslySetInnerHTML={{ __html: offer }}></span>
              </div>
            </>
          )}
        </button>
        {isLoading && (
          <div className="absolute inset-0 cursor-not-allowed flex justify-center items-center bg-white bg-opacity-90">
            <div className="h-9">
              <LoadingSpinner />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PostUpSellDeal;
